<template>
  <div class="draw">
    <img src="../assets/fuli1.png" alt="fuli1" class="fuli1" />
    <div class="banner">
      <div class="prize-list" :style="{transform:rotate_angle,transition:rotate_transition}">
        <div class="prize-item" v-for="item in prizeList" :key="item.position">
          <div class="prize-img">
            <img :src="item.picture" alt="gifts" />
          </div>
          <p class="prize-des" v-if="item.type !== 'NONE'">{{item.prize}}</p>
        </div>
      </div>
      <div class="point">
        <img src="../assets/zhizhen.png" alt="point" />
        <div class="btn" @click.stop="handleDraw()">
          <p class="big">抽奖</p>
          <p class="small">剩余{{lottery_ticket}}次</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { prize_list,draw } from "../config";
export default {
  name: "Draw",
  props:{
    awardChance:{
      type:Number,
      default:0
    }
  },
  data: () => ({
    prizeList: [],
    easejoy_bean: 0, //金豆
    lottery_ticket: 0, //抽奖次数
    toast_control: false, //抽奖结果弹出框控制器
    hasPrize: [], //中奖礼品
    start_rotating_degree: 0, //初始旋转角度
    rotate_angle: 0, //将要旋转的角度
    start_rotating_degree_pointer: 0, //指针初始旋转角度
    rotate_angle_pointer: 0, //指针将要旋转的度数
    rotate_transition: "transform 4s ease-in-out", //初始化选中的过度属性控制
    rotate_transition_pointer: "transform 12s ease-in-out", //初始化指针过度属性控制
    click_flag: true, //是否可以旋转抽奖
    index: 0
  }),
  created() {
    this.$axios({
      withCredentials: true,
      crossDomain: true,
      method: "get",
      url: prize_list
    }).then(res => {
      let { data } = res;
      if (data.code === 0) {
        this.prizeList = data.data;
      }
    });
  },
  watch:{
    awardChance:function(val){
      this.lottery_ticket=val
    }
  },
  methods: {
    //此方法为处理奖品数据
    handleDraw() {
      if(!this.click_flag) return;
      this.$axios({
        withCredentials: true,
        crossDomain: true,
        method: "get",
        url:draw
      }).then(res=>{
        let {data}=res;
        if(data.code !== 0){
           this.$toast({
            message: data.msg,
            duration: 1000,
            position: "bottom"
          });
          return;
        }
          this.rotate_handle(data.data.position)
          this.hasPrize=data.data;
          this.lottery_ticket=data.data.drawTimes
      })
    },
    // init_prize_list(list) {},
    rotate_handle(idx) {
      this.index = idx; //指定每次旋转到的奖品下标
      this.rotating();
    },
    rotating() {
      if (!this.click_flag) return;
      var type = 0; // 默认为 0  转盘转动 1 箭头和转盘都转动(暂且遗留)
      var during_time = 3; // 默认为1s
      // var random = Math.floor(Math.random() * 7);
      var result_index = this.index; // 最终要旋转到哪一块，对应prize_list的下标
      var result_angle = [337.5, 292.5, 247.5, 202.5, 157.5, 112.5, 67.5, 23.5]; //最终会旋转到下标的位置所需要的度数
      var rand_circle = 6; // 附加多转几圈，2-3
      this.click_flag = false; // 旋转结束前，不允许再次触发
      if (type == 0) {
        // 转动盘子
        var rotate_angle =
          this.start_rotating_degree +
          rand_circle * 360 +
          result_angle[result_index] -
          (this.start_rotating_degree % 360);
        this.start_rotating_degree = rotate_angle;
        this.rotate_angle = "rotate(" + rotate_angle + "deg)";
        // // //转动指针
        // this.rotate_angle_pointer = "rotate("+this.start_rotating_degree_pointer + 360*rand_circle+"deg)";
        // this.start_rotating_degree_pointer =360*rand_circle;
        var that = this;
        // 旋转结束后，允许再次触发
        setTimeout(function() {
          that.click_flag = true;
          that.game_over();
        }, during_time * 1000 + 1500); // 延时，保证转盘转完
      } else {
        //
      }
    },
    game_over() {
      this.toast_control = true;
      this.$emit('giftmsg',this.hasPrize)
    },
    //关闭弹窗
    close_toast() {
      this.toast_control = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.draw {
  border-radius: 5px;
  margin: 0 auto;
  width: 620px;
  height: 700px;
  padding: 50px 30px 0;
  background-color: #112b5d;
  box-shadow: 0 0 5px #081839;
  margin-bottom: 20px;
  .fuli1 {
    width: 100%;
    margin-bottom: 35px;
  }
  .banner {
    margin: 0 auto;
    width: 545px;
    height: 545px;
    position: relative;
    .prize-list {
      width: 100%;
      height: 100%;
      background-image: url("../assets/draw.png");
      background-size: 100% 100%;
      position: relative;
      .prize-item {
        width: 173.4px;
        height: 272.5px;
        padding-top: 50px;
        box-sizing: border-box;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        display: flex;
        flex-direction: column;
        align-items: center;
        .prize-img {
          width: 80px;
          height: 80px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .prize-des {
          font-size: 18px;
        }
      }
      .prize-item:first-child {
        top: 0;
        left: 245px;
        transform: rotate(25deg);
      }
      .prize-item:nth-child(2) {
        top: 0.82rem;
        left: 3.2rem;
        transform: rotate(67deg);
      }
      .prize-item:nth-child(3) {
        top: 200px;
        left: 320px;
        transform: rotate(-245deg);
      }
      .prize-item:nth-child(4) {
        top: 270px;
        left: 230px;
        transform: rotate(-198deg);
      }
      .prize-item:nth-child(5) {
        top: 260px;
        left: 115px;
        transform: rotate(-154deg);
      }
      .prize-item:nth-child(6) {
        top: 1.9rem;
        left: 30px;
        transform: rotate(-111deg);
      }
      .prize-item:nth-child(7) {
        top: 80px;
        left: 50px;
        transform: rotate(-65deg);
      }
      .prize-item:nth-child(8) {
        top: -6px;
        left: 140px;
        transform: rotate(-18deg);
      }
    }
    .point {
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 10;
      width: 140px;
      height: 240px;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
      .btn {
        width: 140px;
        height: 140px;
        border-radius: 50%;
        position: absolute;
        bottom: 0;
        left: 0;
        cursor: pointer;
        color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .big {
          font-weight: 34px;
          font-weight: 600;
        }
        .small {
          font-size: 20px;
        }
      }
    }
  }
}
</style>
